import { SHOW_TOAST, REMOVE_TOAST } from './types';

export const showToast = config => ({
  type: SHOW_TOAST,
  config
});

export const removeToast = () => ({
  type: REMOVE_TOAST
});
